"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import * as popout from "./popout";
import {
  attachOcrLineDropListeners,
  forceString,
  formatDate
} from "./ocr_line_drop";
function handleClick(state) {
  popout.setFieldSelection(state.identifier);
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      identifier: ""
    });
    __publicField(this, "inputRef", React.createRef());
    __publicField(this, "detachOcrLineDrop");
    __publicField(this, "applyDroppedValue", (event, value) => {
      const input = this.inputRef.current;
      if (!input) {
        return;
      }
      switch (input.getAttribute("type")) {
        case "date":
          return this.props.onDrop(event, formatDate(value));
        default:
          return this.props.onDrop(event, forceString(value));
      }
    });
    // Bug (DEVEX-963): only document_information passes onValueChange, so a popout
    // line sent to any other caller's input throws. Kept as-is; fix separately.
    __publicField(this, "handlePopoutListenerUpdate", (value) => {
      const input = this.inputRef.current;
      if (!input) {
        return;
      }
      switch (input.getAttribute("type")) {
        case "date":
          return this.props.onValueChange(formatDate(value));
        default:
          return this.props.onValueChange(forceString(value));
      }
    });
  }
  componentDidMount() {
    const input = this.inputRef.current;
    $(input).droppable({
      drop: (event, ui) => {
        return this.applyDroppedValue(event, ui.helper.data("chars"));
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.detachOcrLineDrop = attachOcrLineDropListeners(
      input,
      (payload, event) => this.applyDroppedValue(event, payload.chars)
    );
    this.state.identifier = popout.setupDocPageLineFromPopoutListener(
      this.handlePopoutListenerUpdate
    );
  }
  componentWillUnmount() {
    if (this.detachOcrLineDrop) {
      this.detachOcrLineDrop();
    }
  }
  render() {
    const _a = this.props, { onValueChange } = _a, rest = __objRest(_a, ["onValueChange"]);
    const inputProps = rest;
    if (onValueChange) {
      inputProps.onChange = (e) => onValueChange(e.target.value);
    }
    return /* @__PURE__ */ jsx(
      "input",
      __spreadProps(__spreadValues({
        ref: this.inputRef
      }, inputProps), {
        onClick: () => handleClick(this.state)
      })
    );
  }
}
